import React from "react";

import "./styles/education.css";

const Education = ({ institution, course, duration, logo }) => {
  return (
    <div className="education">
      <div className="education-institution-image">
        <img src={logo} alt={institution} />
      </div>
      <div className="education-details">
        <h3 className="education-institution">{institution}</h3>
        <p className="education-course">{course}</p>
        <p className="education-duration">{duration}</p>
      </div>
      <div className="point"></div>
    </div>
  );
};

export default Education;
